import { CSSObject } from "@emotion/react";
import { mediaQueryStyles, constants } from "@newsela/angelou";

import { SmallScreenPanelZIndex } from "../ContentLayout/ContentLayout.style";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const AssignModalZIndex = 14;

export const rootCss: CSSObject = {
  zIndex: AssignModalZIndex,

  overflow: "scroll",
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.md)]: {
    zIndex: SmallScreenPanelZIndex + 1,
  },
};

export const scrollableBodyCss = {
  flex: 1,
};

export const infoModalCss = {
  "&&": {
    maxWidth: "994px",
  },
};
